import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Camping = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Aventura";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.headerCamping})` }}>
        <div className="servico-hero-overlay">
          <h1>Aventura</h1>
          {/*  <p>Para quem procura por aventuras</p> */}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Camping e Tabacaria */}
        <section className="acessorios-grid">

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.binoculos} alt="" /></div>
            <h3>Observação</h3>
            <p>Binóculos e telescópios.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.bussolas} alt="" /></div>
            <h3>Orientação</h3>
            <p>Bússolas.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.canivetes} alt="" /></div>
            <h3>Corte</h3>
            <p>Canivetes e facas esportivas.</p>
          </div>
        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('aventuras')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('aventuras')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Camping;